import { useEffect } from "react";

const KeepAlive = () => {
  useEffect(() => {
    const ping = async () => {
      try {
        await fetch("https://albiemer.onrender.com/health/");
        console.log("KeepAlive ping success");
      } catch (err) {
        console.warn("KeepAlive ping failed:", err); // ONLY warn, don't throw
      }
    };

    ping(); // initial ping
    const interval = setInterval(ping, (5 + Math.random() * 2) * 60 * 1000); // 5–7 min
    return () => clearInterval(interval);
  }, []);

  return null; // must return null
};

export default KeepAlive;
